import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Stack,
  Link,
  useTheme,
} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const Check = () => <CheckCircle sx={{ color: '#06bf58', width: 24, height: 24 }} />;
const Cross = () => <HighlightOffIcon sx={{ color: '#fa0303', width: 28, height: 28 }} />;

/**
 * @param {{ features: { featureName: string; platformSupport: Record<string, 0 | 1> }[] }} props
 */

const SemanticSearchPlatformComparison = ({ features }) => {
  const theme = useTheme();
  const tableCellStyle = {
    backgroundColor: theme.palette.mode === 'dark' ? '#2c2c2c' : '#f5f5f5',
  };

  if (!features || features.length === 0) {
    return null;
  }

  // Assume all features share the same set of platforms
  const platforms = Object.keys(features[0].platformSupport);

  return (
    <Stack sx={{ width: '100%' , marginBottom: 8}}>
      <TableContainer component={Paper} sx={{ boxSizing: 'border-box', boxShadow: 0, border: `2px solid ${tableCellStyle.backgroundColor}`, borderRadius: 2, width: '100%' }}>
        <Table
          sx={{
            border: 'none',
            '& td, & th': {
              border: 'none',
            },
            '& .MuiTableCell-root': {
              textAlign: 'center',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <Link
                  href="https://consensus.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Consensus
                  </Typography>
                </Link>
              </TableCell>
              <TableCell>
                <Link
                  href="https://www.perplexity.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Perplexity
                  </Typography>
                </Link>
              </TableCell>
              <TableCell>
                <Link
                  href="https://www.semanticscholar.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="none"
                >
                  <Typography fontSize={18} fontWeight="medium">
                    Semantic Scholar
                  </Typography>
                </Link>
              </TableCell>
              <TableCell
                sx={tableCellStyle}
              >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img
                    src="/logo.png"
                    alt="Endoc logo"
                    style={{
                      height: '40px',
                      width: '35px',
                      marginRight: '8px',
                    }}
                  />
                  <Typography fontSize={18} fontWeight="bold">
                    Endoc
                  </Typography>
                </div>
              </TableCell>

            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>
                <Typography fontSize={20} fontWeight="bold" align={'left'}>
                  Filter by
                </Typography>
              </TableCell>

              <TableCell>
              </TableCell>

              <TableCell>
              </TableCell>

              <TableCell>
              </TableCell>

              <TableCell sx={tableCellStyle}>
              </TableCell>
            </TableRow>

            {features.map(({ featureName, platformSupport }, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography
                      fontFamily="Roboto, sans-serif"
                      fontSize={16}
                      lineHeight={1.2}
                      textAlign="left"
                      sx={{ pl: 2 }}
                    >
                      {featureName}
                    </Typography>
                  </Stack>
                </TableCell>

                {platforms.map((platform) => (
                  <TableCell
                    key={platform}
                    sx={platform === 'Endoc' ? tableCellStyle : {}}
                  >
                    {platformSupport[platform] ? <Check /> : <Cross />}
                  </TableCell>
                ))}
              </TableRow>
            ))}

            <TableRow>
              <TableCell>
                <Typography
                  align={'left'}
                  fontSize={20}
                  fontWeight="bold"
                >
                  Search for papers <br />
                  by custom note
                </Typography>
              </TableCell>
              <TableCell>
                <Cross />
              </TableCell>
              <TableCell>
                <Cross />
              </TableCell>
              <TableCell>
                <Cross />
              </TableCell>
              <TableCell sx={tableCellStyle}>
                <Check />
              </TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default SemanticSearchPlatformComparison;
